// Template210: Osaka - Día 2 Dotonbori contenido (Page4)
// Hozenji Yokocho, Dotonbori, Glico Man, calles, kuidaore, Por la noche.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template210 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const hozenjiTitle = page?.texts?.[1]?.content;
	const hozenjiBody = page?.texts?.[2]?.content;
	const dotonboriTitle = page?.texts?.[3]?.content;
	const dotonboriBody = page?.texts?.[4]?.content;
	const tipComida = page?.texts?.[5]?.content;
	const tipFoto = page?.texts?.[6]?.content;
	const glicoTitle = page?.texts?.[7]?.content;
	const glicoBody = page?.texts?.[8]?.content;
	const kuidaoreBox = page?.texts?.[9]?.content;
	const nocheTitle = page?.texts?.[10]?.content;
	const nocheBody = page?.texts?.[11]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const dotonboriImage = getImageSrc("dotonbori");
	const glicoImage = getImageSrc("glico");
	const callesImage = getImageSrc("calles");
	const comiendoImage = getImageSrc("comiendo");
	const glicoSticker = getImageSrc("glicoSticker");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];

	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const contentColor = textColor || "#444";

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					flex: 1,
					display: "flex",
					flexDirection: "column",
					gap: 2,
				}}
			>
				{/* Hozenji Yokocho */}
				{(hozenjiTitle || hozenjiBody) && (
					<Box
						data-block-id="text-2"
						sx={{
							backgroundColor: "#d1e6de",
							borderRadius: "12px",
							padding: "8px 16px",
							fontSize: "13px",
							textAlign: "left",
							color: contentColor,
							position: "relative",
						}}
					>
						{hozenjiTitle && (
							<Box component="h3" sx={estiloH3}>
								{hozenjiTitle}
							</Box>
						)}
						{hozenjiBody && (
							<Box component="p" sx={estiloP}>
								{hozenjiBody}
							</Box>
						)}
					</Box>
				)}

				{/* Dotonbori */}
				<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
					{dotonboriImage && (
						<Box
							component="img"
							src={dotonboriImage}
							alt=""
							sx={{
								width: "40%",
								height: 110,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{dotonboriTitle && (
							<Box component="h3" sx={estiloH3}>
								{dotonboriTitle}
							</Box>
						)}
						{dotonboriBody && (
							<Box component="p" sx={estiloP}>
								{dotonboriBody}
							</Box>
						)}
					</Box>
				</Box>

				{/* Glico Man section */}
				<Box
					sx={{
						flex: 1,
						display: "flex",
						flexDirection: "column",
						gap: 2,
						position: "relative",
					}}
				>
					{comiendoImage && (
						<Box
							component="img"
							src={comiendoImage}
							alt=""
							sx={{
								width: 95,
								position: "absolute",
								bottom: isSmallScreen ? -220 : -140,
								left: isSmallScreen ? -30 : 0,
							}}
						/>
					)}
					{tipComida && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? -150 : -30,
								left: isSmallScreen ? 0 : 30,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 16px 0px",
								padding: "10px 12px",
								fontSize: 11,
								color: contentColor,
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: isSmallScreen ? 180 : 220,
							}}
						>
							{tipComida}
						</Box>
					)}
					{glicoSticker && (
						<Box
							component="img"
							src={glicoSticker}
							alt=""
							sx={{
								width: 95,
								position: "absolute",
								bottom: isSmallScreen ? -140 : -20,
								right: isSmallScreen ? -10 : 0,
							}}
						/>
					)}
					{tipFoto && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? -100 : 10,
								right: isSmallScreen ? 50 : 75,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "10px 12px",
								fontSize: 11,
								color: contentColor,
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: isSmallScreen ? 100 : 160,
							}}
						>
							{tipFoto}
						</Box>
					)}
					<Box sx={{ display: "flex", gap: 2, alignItems: "flex-start" }}>
						{glicoImage && (
							<Box
								component="img"
								src={glicoImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									borderRadius: "12px",
									objectFit: "cover",
								}}
							/>
						)}
						<Box
							sx={{ width: "60%", position: "relative", marginTop: "-15px" }}
						>
							{sabiasQue.length > 0 && (
								<>
									<Box sx={{ position: "relative", top: 0, right: -50 }}>
										<SabiasQue
											icono={sabiasQue[0]?.icono ?? "📸"}
											texto={sabiasQue[0]?.texto ?? ""}
										/>
									</Box>
									{sabiasQue[1] && (
										<Box sx={{ position: "absolute", top: 0, left: 0 }}>
											<SabiasQue
												icono={sabiasQue[1]?.icono ?? "🦑"}
												texto={sabiasQue[1]?.texto ?? ""}
											/>
										</Box>
									)}
								</>
							)}
							{glicoTitle && (
								<Box component="h3" sx={estiloH3}>
									{glicoTitle}
								</Box>
							)}
							{glicoBody && (
								<Box component="p" sx={estiloP}>
									{glicoBody}
								</Box>
							)}
						</Box>
					</Box>
				</Box>
			</Box>

			{callesImage && (
				<Box
					data-block-id="image-0"
					component="img"
					src={callesImage}
					alt=""
					sx={{
						width: "100%",
						minHeight: isSmallScreen ? "200px" : "100px",
						height: isSmallScreen ? "200px" : "120px",
						objectFit: "cover",
					}}
				/>
			)}

			<Box data-block-id="text-5" sx={{ padding: "10px 12px", position: "relative" }}>
				{kuidaoreBox && (
					<Box
						sx={{
							backgroundColor: "#d1e6de",
							border: "2px solid #1F4E3D",
							borderRadius: "12px",
							padding: "8px 14px",
							fontSize: "12px",
							color: contentColor,
							textAlign: "center",
						}}
						dangerouslySetInnerHTML={{ __html: kuidaoreBox }}
					/>
				)}
			</Box>

			<Box data-block-id="text-6" sx={{ position: "relative" }}>
				<Box sx={{ padding: "10px 12px", position: "relative" }}>
					{sabiasQue[2] && (
						<Box sx={{ position: "absolute", top: 0, left: "50%" }}>
							<SabiasQue
								icono={sabiasQue[2]?.icono ?? "🎭"}
								texto={sabiasQue[2]?.texto ?? ""}
							/>
						</Box>
					)}
					{nocheTitle && (
						<Box component="h3" sx={estiloH3}>
							{nocheTitle}
						</Box>
					)}
					{nocheBody && (
						<Box component="p" sx={estiloP}>
							{nocheBody}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template210.thumbnail = "/images/template-1.png";
export default Template210;
